/*
 * storefront-worker.js
 * --------------------
 * Thin, safe client for the Cloudflare Worker. Loaded globally and deferred, so
 * it never blocks rendering. It exposes one helper, `StorefrontWorker.call()`,
 * and does nothing automatic beyond an optional debug health ping.
 *
 * Fail open: every request has a timeout and resolves to `null` on any error,
 * so the storefront keeps working even if the Worker is slow or unavailable.
 *
 * No secrets here — this file only knows the public Worker URL. No tracking,
 * no cookies (credentials are omitted), no hidden requests.
 */
(function () {
  var cfg = window.__STOREFRONT_WORKER__ || {};
  if (!cfg.url) return;

  var base = String(cfg.url).replace(/\/$/, '');
  var timeoutMs = cfg.timeoutMs || 8000;

  /**
   * call(path, init) -> Promise resolving to parsed JSON/text, or null on failure.
   * Example: StorefrontWorker.call('/config').then(function (r) { ... });
   */
  function call(path, init) {
    init = init || {};
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, timeoutMs) : null;

    var options = {
      method: init.method || 'GET',
      credentials: 'omit', // no cookies -> no ambient tracking
      headers: Object.assign({ 'Content-Type': 'application/json' }, init.headers || {}),
    };
    if (init.body != null) {
      options.body = typeof init.body === 'string' ? init.body : JSON.stringify(init.body);
    }
    if (controller) options.signal = controller.signal;

    return fetch(base + path, options)
      .then(function (res) {
        if (!res.ok) throw new Error('worker_http_' + res.status);
        var ct = res.headers.get('Content-Type') || '';
        return ct.indexOf('application/json') > -1 ? res.json() : res.text();
      })
      .catch(function (err) {
        if (cfg.debug) console.warn('[storefront-worker] ' + path + ' failed:', err && err.message);
        return null; // fail open
      })
      .then(function (value) {
        if (timer) clearTimeout(timer);
        return value;
      });
  }

  window.StorefrontWorker = { base: base, call: call };

  // Optional, debug-only liveness ping so you can confirm it runs on every page.
  // Off unless "Debug logging" is enabled in theme settings. Not tracking.
  if (cfg.debug) {
    call('/health').then(function (r) {
      console.log('[storefront-worker] ready ->', base, '| health:', r);
    });
  }
})();
